import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Update entity data
 * @param {number} entityId - The entity ID to update
 * @param {object} entityData - The entity data to update
 * @returns {Promise} Response with success status
 */
export const updateEntityAction = async (entityId, entityData) => {
    try {
        // Prepare payload - ensure all required fields are present
        const payload = {
            id: entityData.id || 0,
            entityId: entityData.entityId || "",
            entityName: entityData.entityName || "",
            entityAddress: entityData.entityAddress || "",
            aaDepartmentFunction: entityData.aaDepartmentFunction || "",
            natureOfBusiness: entityData.natureOfBusiness || "",
            entityType: entityData.entityType || "",
            panNumber: entityData.panNumber || "",
            isGSTRegistered: entityData.isGSTRegistered || false,
            gstNumber: entityData.gstNumber || "",
            otherGSTNumbers: entityData.otherGSTNumbers || "",
            isRegisteredUnderMSME: entityData.isRegisteredUnderMSME || false,
            contactPerson: entityData.contactPerson || "",
            designation: entityData.designation || "",
            mobileNumber: entityData.mobileNumber || "",
            emailAddress: entityData.emailAddress || "",
            thirdPartyPayment: entityData.thirdPartyPayment || false,
            relationWithBeneficiary: entityData.relationWithBeneficiary || "",
            bankName: entityData.bankName || "",
            branchNameAndAddress: entityData.branchNameAndAddress || "",
            beneficiaryName: entityData.accountType || "",
            accountNumber: entityData.accountNumber || "",
            ifscCode: entityData.ifscCode || "",
            sendMeEmail: entityData.sendMeEmail || false,
            entityCategory: entityData.entityCategory || "",
            lobType: entityData.lobType || "",
            lobNationality: entityData.lobNationality || "",
            documentUploadURL: entityData.documentUploadURL || "",
            createdOn: entityData.createdOn || new Date().toISOString(),
            modifiedOn: new Date().toISOString()
        };

        const response = await apiClient.put(
            `${ATP_API_URL.UPDATE_ALL_DATA}/${entityId}`,
            payload
        );

        if (response?.status === 200) {
            return {
                success: true,
                data: response.data,
                message: "Entity updated successfully"
            };
        }

        return {
            success: false,
            message: "Failed to update entity"
        };
    } catch (error) {
        console.error("❌ Error updating entity:", error);
        return {
            success: false,
            message: error.message || "Failed to update entity",
            error
        };
    }
};
